$(function () {

  function getFieldValue(selector) {
  const el = $(selector)[0];
  if (el && el.selectize) return el.selectize.getValue();
  return $(selector).val();
}

function setFieldValue(selector, value) {
  const el = $(selector)[0];
  if (el && el.selectize) {
    el.selectize.setValue(value, true);
    return;
  }
  $(selector).val(value);
}

function clearFieldValue(selector) {
  const el = $(selector)[0];
  if (el && el.selectize) {
    el.selectize.clear(true);
    return;
  }
  $(selector).val("");
}


  // if, on page load, the sort_field and sort_order are set in localStorage, set the form values to those values
  if (
    localStorage.getItem("sort_field") !== null &&
    localStorage.getItem("sort_order") !== null
  ) {
    // Find the element with the data-sort attribute that matches the sort_field value
    var element = $(
      "span[data-sort='" + localStorage.getItem("sort_field") + "']"
    );
    // Give the element the correct class according to the sort_order value
    if (localStorage.getItem("sort_order") === "DESC") {
      element
        .find(
          ".nameIcon, .date_createdIcon, .idIcon, .date_modifiedIcon, .statusIcon, .source_idIcon, .target_idIcon, .typeIcon, .source_date_modifiedIcon"
        )
        .removeClass("fa-angle-down")
        .addClass("fa-angle-up");
    } else {
      element
        .find(
          ".nameIcon, .date_createdIcon, .idIcon, .date_modifiedIcon, .statusIcon, .source_idIcon, .target_idIcon, .typeIcon, .source_date_modifiedIcon"
        )
        .removeClass("fa-angle-up")
        .addClass("fa-angle-down");
    }
  }

  $("span").on("click", function () {
    var icon = $(this).find(
      ".nameIcon, .date_createdIcon, .idIcon, .date_modifiedIcon, .statusIcon, .source_idIcon, .target_idIcon, .typeIcon, .source_date_modifiedIcon"
    ); // Trouver l'icône dans l'élément cliqué
    if (icon.hasClass("fa-angle-down")) {
      icon.removeClass("fa-angle-down").addClass("fa-angle-up");
      $("#combined_filter_document_sort_field").val($(this).data("sort"));
      $("#combined_filter_document_sort_order").val("DESC");
      localStorage.setItem("sort_field", $(this).data("sort"));
      localStorage.setItem("sort_order", "DESC");
      $("form").submit();
    } else {
      icon.removeClass("fa-angle-up").addClass("fa-angle-down");
      $("#combined_filter_document_sort_field").val($(this).data("sort"));
      $("#combined_filter_document_sort_order").val("ASC");
      localStorage.setItem("sort_field", $(this).data("sort"));
      localStorage.setItem("sort_order", "ASC");
      $("form").submit();
    }
  });

  // Define an array of filters, each containing a name and selector
  var filters = [
    { name: "name", selector: "#combined_filter_rule_name" },
    { name: "reference", selector: "#combined_filter_document_reference" },
    { name: "moduleSource", selector: "#combined_filter_rule_moduleSource" },
    { name: "moduleTarget", selector: "#combined_filter_rule_moduleTarget" },
    { name: "status", selector: "#combined_filter_document_status" },
    {
      name: "globalStatus",
      selector: "#combined_filter_document_globalStatus",
    },
    { name: "sourceId", selector: "#combined_filter_document_sourceId" },
    { name: "target", selector: "#combined_filter_document_target" },
    { name: "type", selector: "#combined_filter_document_type" },
    { name: "message", selector: "#combined_filter_message_message" },
    {
      name: "date_modif_start",
      selector: "#combined_filter_document_date_modif_start",
    },
    {
      name: "date_modif_end",
      selector: "#combined_filter_document_date_modif_end",
    },
    {
      name: "sourceContent",
      selector: "#combined_filter_sourceContent_sourceContent",
    },
    {
      name: "targetContent",
      selector: "#combined_filter_sourceContent_targetContent",
    },
  ];

  function showFilter(filter) {
    if (filter && filter.selector) {
      var filterValue = getFieldValue(filter.selector);
      if (
        filterValue !== undefined &&
        filterValue !== null &&
        filterValue !== "" &&
        filterValue.length > 0
      ) {
        $("#" + filter.name).removeAttr("hidden");
      }
    }
  }

  // Function to hide a filter and clear its value
  function hideFilter(filter) {
  clearFieldValue(filter.selector);
  $("#" + filter.name).attr("hidden", true);
}

  // Show all filters that have a value initially
  filters.forEach(function (filter) {
    showFilter(filter);
  });

  // Show default filters
  function showDefaultFilters() {
    ["name", "sourceId", "globalStatus"].forEach(function (
      filterName
    ) {
      $("#" + filterName).removeAttr("hidden");
    });
    rearrangeFilters();
  }

  // Call the function to show default filters
  showDefaultFilters();

  // Show a filter when the corresponding option is selected
  $("#item_filter_filter").on("change", function () {
    var $select = $(this);
    var selectedValue = $(this).val();
    $("#" + selectedValue).removeAttr("hidden");
    if (
      selectedValue !== "date_modif_start" &&
      selectedValue !== "date_modif_end" &&
      selectedValue !== "sourceId" &&
      selectedValue !== "target" &&
      selectedValue !== "sourceContent" &&
      selectedValue !== "targetContent" &&
      selectedValue !== "message"
    ) {
      // If there isn't already a reverse checkbox, add one
      if (!$('[name="' + selectedValue + '"][type="checkbox"]').length) {
        $(".removeFilters." + selectedValue).after(
          '<div class="form-check form-switch mt-3"><input class="form-check-input p-2" type="checkbox" role="switch" name="' +
            selectedValue +
            '" value="reverse"><label for="' +
            selectedValue +
            '">Reverse</label></div>'
        );
      }
    }
    rearrangeFilters();
    $select[0].selectize.clear(true); 
  });

  // Save filters to localStorage
  function saveFiltersToLocalStorage() {
    var storedFilters = {};
    filters.forEach(function (filter) {
      storedFilters[filter.name] = {
        value: getFieldValue(filter.selector),
        hidden: $("#" + filter.name).attr("hidden") === "hidden",
        reverse: $('[name="' + filter.name + '"][type="checkbox"]').prop(
          "checked"
        ),
      };
    });

    // console.log('storedFilters filter.js', storedFilters);

    localStorage.setItem("storedFilters", JSON.stringify(storedFilters));
  }

  function loadFiltersFromLocalStorage() {
    var storedFilters = JSON.parse(localStorage.getItem("storedFilters"));
    if (storedFilters) {
      filters.forEach(function (filter) {
        if (storedFilters[filter.name]) {
          setFieldValue(filter.selector, storedFilters[filter.name].value);
          if (storedFilters[filter.name].hidden) {
            hideFilter(filter);
          } else {
            showFilter(filter);
            if (
              filter.name !== "date_modif_start" &&
              filter.name !== "date_modif_end" &&
              filter.name !== "sourceId" &&
              filter.name !== "target" &&
              filter.name !== "sourceContent" &&
              filter.name !== "targetContent" &&
              filter.name !== "message"
            ) {
              $(".removeFilters." + filter.name).after(
                '<div class="form-check form-switch mt-3"><input class="form-check-input p-2" type="checkbox" role="switch" name="' +
                  filter.name +
                  '" value="reverse"><label for="' +
                  filter.name +
                  '">Reverse</label></div>'
              );
              $('[name="' + filter.name + '"][type="checkbox"]').prop(
                "checked",
                storedFilters[filter.name].reverse
              );
            }
          }
        }
      });
    }
    rearrangeFilters();
  }

  // Load filters from localStorage on page load
  loadFiltersFromLocalStorage();

  // Save filters to localStorage when the form is submitted
  $("form").on("submit", function () {
    saveFiltersToLocalStorage();
  });

  // if a link with the class page-link is clicked, save the filters to localStorage
  $(".page-link").on("click", function () {
    saveFiltersToLocalStorage();
    loadFiltersFromLocalStorage();
  });

  // Remove Filter
  $(".removeFilters").on("click", function () {
    var lastClass = $(this).attr("class").split(" ").pop();
    filters.forEach(function (filter) {
      if (filter.name === lastClass) {
        hideFilter(filter);
        localStorage.removeItem("storedFilters");
      }
    });
    // Reset dropdown to default so the same filter can be re-selected
    $("#item_filter_filter").val($("#item_filter_filter option:first").val());
    rearrangeFilters();
  });
});

function rearrangeFilters() {
  var visibleFilters = $("#filters-container > div:visible");
  visibleFilters.each(function (index, filter) {
    $(filter).appendTo("#filters-container");
  });
}

$(document).ready(function() {

    let pop=null; 
    const close=()=>{ if(pop){ pop.remove(); pop=null; } };
    const esc=(e)=>{ if(e.key==='Escape') close(); };
    const outside=(e)=>{ if(pop && !pop.contains(e.target)) close(); };

function show(anchor, text){
    close();
    pop=document.createElement('div');
    pop.className='popover';
    pop.innerHTML=`<button class="close-x" aria-label="Close">&times;</button>${text}`;
    document.body.appendChild(pop);

    const r=anchor.getBoundingClientRect();
    const px=window.scrollX, py=window.scrollY;
    pop.style.left=(r.left+px - 10)+'px';
    pop.style.top =(r.bottom+py + 10)+'px';

    pop.querySelector('.close-x').addEventListener('click', close, {once:true});
    setTimeout(()=>document.addEventListener('click', outside, {once:true}),0);
    document.addEventListener('keydown', esc, {once:true});
  }

  document.addEventListener('click', e=>{
    const icon=e.target.closest('.help-pop[data-help]');
    if(!icon) return;
    e.preventDefault(); e.stopPropagation();
    show(icon, icon.getAttribute('data-help')||'');
  });

});

